import { Service } from './base';

export class DlaClient extends Service {}
